(function ($) {
  $(function () {
    if ($('.team-testimonial-card__wrapper').length) {
      $(window).on('load resize', function () {
        var $teamTestimonialCardsWrapper = $('.team-testimonial-card__wrapper');
        var windowWidth = $(window).width();
        var teamTestimonialCardsCount = $teamTestimonialCardsWrapper.find('.team-testimonial-card').length;
        var isSlicked = $teamTestimonialCardsWrapper.hasClass('slick-initialized');

        if (teamTestimonialCardsCount < 4) {
          $teamTestimonialCardsWrapper.addClass('justify-content-center');
        }

        if (windowWidth < 991 && teamTestimonialCardsCount > 4 && !isSlicked) {
          $teamTestimonialCardsWrapper.slick({
            infinite: false,
            swipe: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            slidesToSwipe: 1,
            arrows: false,
            responsive: [
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 3,
                  dots: true,
                },
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  dots: true,
                },
              }
            ],
          });
        } 

        if (windowWidth <= 991 && windowWidth >= 768 && teamTestimonialCardsCount > 3 && !isSlicked) {
          $teamTestimonialCardsWrapper.slick({
            infinite: false,
            swipe: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            slidesToSwipe: 1,
            arrows: false,
            dots: true,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  dots: true,
                },
              }
            ],
          });
        } 

        if (windowWidth > 991 &&  teamTestimonialCardsCount > 3 && isSlicked) { 
          $teamTestimonialCardsWrapper.slick('unslick');
        }

        if (windowWidth < 768 && teamTestimonialCardsCount > 1 && !isSlicked) {
          $teamTestimonialCardsWrapper.slick({
            infinite: false,
            swipe: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            slidesToSwipe: 1,
            arrows: false,
            dots: true
          });
        } else if (windowWidth < 768 && teamTestimonialCardsCount <= 1 && isSlicked) {
          $teamTestimonialCardsWrapper.slick('unslick');
        }
      });
    }
  });
})(jQuery);